import { EditOutlined, LockOutlined } from '@ant-design/icons'
import { Button, Form, Input, Modal } from 'antd'
import { debounce } from 'lodash'
import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Loading } from 'src/common'
import { GLOBAL_CLIENT } from 'src/helpers/GlobalClient'
import { ERROR_CODES } from 'src/helpers/constants'
import { showMessageSuccess } from 'src/helpers/functions'
import i18n from 'src/helpers/i18n'
import { createValidationRules } from 'src/helpers/validateRule'
import { useStore } from 'src/hooks'
import styled from 'styled-components'

type PasswordModalProps = {
   isPasswordModalOpen: boolean
   handleCancel: () => void
}

const PasswordModalWrapper = styled.div``

const PasswordModal: React.FC<PasswordModalProps> = ({ isPasswordModalOpen, handleCancel }) => {
   const [form] = Form.useForm()
   const onFinishFailed = (errorInfo: any) => {}
   const { t } = useTranslation()
   const UserStore = useStore('UserStore')
   const [isLoading, setIsLoading] = useState(false)
   // Re-create rules when language changes
   const rule = useMemo(() => createValidationRules(), [i18n.language])
   const onFinish = async (values: any) => {
      try {
         setIsLoading(true)
         Object.keys(values)?.forEach((k) => (values[k] = values[k]?.trim()))
         const { newPassword, currentPassword } = values
         const result = await UserStore.action_resetPassword({ newPassword, currentPassword })
         console.log('result', JSON.stringify(result))

         if (result) {
            showMessageSuccess('Đổi mật khẩu thành công')
            handleCancel()
         }
      } catch (error) {
         // console.log(error)
      } finally {
         setIsLoading(false)
      }
   }
   return (
      <Modal title="Đổi mật khẩu" visible={isPasswordModalOpen} onCancel={handleCancel} footer={null}>
         <Loading isLoading={isLoading} />
         <PasswordModalWrapper>
            <Form
               form={form}
               name="basic"
               onFinish={debounce(onFinish, 600)}
               onFinishFailed={onFinishFailed}
               className="gx-signin-form gx-form-row0"
            >
               <Form.Item rules={[rule.passwordRule]} name="currentPassword">
                  <Input.Password
                     placeholder={t('password')}
                     prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                     maxLength={30}
                  />
               </Form.Item>
               <Form.Item rules={[rule.passwordRule]} name="newPassword">
                  <Input.Password
                     placeholder={t('new_password')}
                     prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                     maxLength={30}
                  />
               </Form.Item>
               <Form.Item
                  rules={[
                     rule.requiredPassword,
                     ({ getFieldValue }) => ({
                        validator(_, value) {
                           if (!value || getFieldValue('newPassword') === value) {
                              return Promise.resolve()
                           }
                           return Promise.reject(new Error(t('matkhaukhongtrungkhop')))
                        }
                     })
                  ]}
                  name="confirm_password"
                  dependencies={['new_password']}
               >
                  <Input.Password
                     placeholder={t('confirm_password')}
                     prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                     maxLength={30}
                  />
               </Form.Item>
               <Form.Item>
                  <Button icon={<EditOutlined />} type="primary" className="gx-mb-0" htmlType="submit">
                     {t('update')}
                  </Button>
               </Form.Item>
            </Form>
         </PasswordModalWrapper>
      </Modal>
   )
}

export default PasswordModal
